(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('CategoryAddController', CategoryAddController);

    /* @ngInject */
    function CategoryAddController(
        logger,
        userCategoryService,        
        $uibModalInstance) {

        var vm = this;
        vm.title = 'Add Category';
        vm.userCategory = userCategoryService.getDefaultUserCategory();
        vm.userCategoryFields = userCategoryService.getUserCategoryFields();

        vm.save = save;
        vm.reset = reset;

        activate();

        function activate() {
            setForm();
        }

        function save() {
            if (vm.userCategoryForm.$valid) {
                userCategoryService.saveUserCategory(vm.userCategory)
                    .then(function (result) {
                        if (result.status === 200) {
                            $uibModalInstance.close(result.data);
                        } else {
                            logger.info('Error saving user category');
                        }
                        
                    });            
            }
        }

        function reset() {
            vm.userCategoryForm.options.resetModel();
            $uibModalInstance.dismiss('cancel');
        }

        function setForm() {
        }
    }
})();
